import React from 'react';

import { UnitContainer } from './styles';

type UnitProps = {
  children: React.ReactNode;
};

const Unit = ({ children }: UnitProps) => {
  return <UnitContainer>{children}</UnitContainer>;
};

export default Unit;
